import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAsterisk: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAsterisk"><Path fillRule="evenodd" clipRule="evenodd" d="M12.7501 2V10.7015L20.2863 6.35048L21.0363 7.64952L13.5006 12.0003L21.0354 16.3505L20.2854 17.6495L12.7501 13.299V22H11.2501V13.2996L3.71581 17.6495L2.96581 16.3505L10.5006 12.0003L2.96484 7.64952L3.71484 6.35048L11.2501 10.701V2H12.7501Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAsterisk;
